export class PrePolicyModel {
    public PolicyNumber: string;
    public PaymentReferenceNumber: string;
}
